import { UserNotificationType } from 'modules/domain/userNotifications/types'

export const getNotificationTypeDisplayName = (type: UserNotificationType): string => {
  switch (type) {
    case 'digital_asset':
      return 'Digital Asset'
    case 'link_asset':
      return 'Link Asset'
    default:
      return 'Notification'
  }
}

export const getNotificationIcon = (type: UserNotificationType): string => {
  switch (type) {
    case 'digital_asset':
      return 'FileTextOutlined'
    case 'link_asset':
      return 'LinkOutlined'
    default:
      return 'BellOutlined'
  }
}

export const formatNotificationTitle = (notification: {
  user_notification_title?: string
  user_notification_type: UserNotificationType
}): string => {
  return notification.user_notification_title || getNotificationTypeDisplayName(notification.user_notification_type)
}

export const formatNotificationText = (notification: { user_notification_text?: string }): string => {
  return notification.user_notification_text || 'No description available'
}
